// extracted by mini-css-extract-plugin
module.exports = {"clickArea":"MobileClickArea_clickArea__0EkJ8","title":"MobileClickArea_title__wHNIU"};